import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class ConsultantDecisionService {
  public reviewData: any = {};
  constructor(private http: HttpClient) { }

  getAllReqAccomms(data) {
    return this.http.get("api/internalconsultantdecision/getAllReqAccomms", {
      params: {
        REQUEST_ID: data.REQUEST_ID
      },
      responseType: "json"
    });
  }

  getReqAccomms(data) {
    return this.http.get("api/internalconsultantdecision/reqAccomms", {
      params: {
        REQUEST_ID: data.REQUEST_ID,
        REVIEW_DETAIL_ID: data.REVIEW_DETAIL_ID
      },
      responseType: "json"
    });
  }
  getReviewDetails(data) {
    return this.http.get(
      "api/internalconsultantdecision/getReviewDetailsByReqId",
      {
        params: {
          REQUEST_ID: data
        },
        responseType: "json"
      }
    );
  }
  getAllStatusCode() {
    return this.http.get("api/internalconsultantdecision/getAllStatusCode", {
      responseType: "json"
    });
  }
  deleteReqAccomms(REQUESTED_ACCOMMODATION_ID) {
    return this.http.delete(`/api/internalconsultantdecision/deleteReqAccomm`, {
      params: { REQUESTED_ACCOMMODATION_ID: REQUESTED_ACCOMMODATION_ID },
      responseType: "json",
      observe: "response"
    });
  }
  deleteReqAccommForUpdate(REVIEW_DETAIL_ACCOMM_STATUS_ID) {
    return this.http.delete(
      `/api/internalconsultantdecision/deleteReqAccommForUpdate`,
      {
        params: {
          REVIEW_DETAIL_ACCOMM_STATUS_ID: REVIEW_DETAIL_ACCOMM_STATUS_ID
        },
        responseType: "json",
        observe: "response"
      }
    );
  }
  submit(data) {
    if (data.EXP_DATE) {
      data.EXP_DATE = moment(data.EXP_DATE).format(
        "DD-MMM-YY hh.mm.ss.SSSSSSSSS a"
      );
    }
    return this.http.post(
      `/api/internalconsultantdecision/postRequestedAccommodation`,
      data,
      { observe: "response" }
    );
  }
  reviewAccommSubmit(data) {
    if (data.EXP_DATE) {
      data.EXP_DATE = moment(data.EXP_DATE).format(
        "DD-MMM-YY hh.mm.ss.SSSSSSSSS a"
      );
    }
    return this.http.post(
      `/api/internalconsultantdecision/postReviewDetailAccomms`,
      data,
      { observe: "response" }
    );
  }
  reqSubmit(data) {
    if (data.EXP_DATE) {
      data.EXP_DATE = moment(data.EXP_DATE).format(
        "DD-MMM-YY hh.mm.ss.SSSSSSSSS a"
      );
    }
    return this.http.put(
      `/api/internalconsultantdecision/updateRequestedAccommodation`,
      data,
      { observe: "response" }
    );
  }

  updateRequestAccommDecision(data) {
    return this.http.put(
      `/api/internalconsultantdecision/updateRequestDecision`,
      data,
      { observe: "response" }
    );
  }

  setReviewData(data) {
    this.reviewData = data;
  }

  getReviewData() {
    return this.reviewData;
  }

  generateDecisionDocument(documentData) {
    return this.http.post(
      `/api/internals3decisiondoc/generateDecisionDocument`,
      documentData,
      { observe: "response" }
    );
  }

  previewDecisionFile() {
    return window.open(`/api/internals3decisiondoc/previewDecisionDocument`);
  }

  uploadDecisionDocument(documentData) {
    return this.http.post(
      `/api/internals3decisiondoc/uploadDecisionDocument`,
      documentData,
      { observe: "response" }
    );
  }

  storeDecisionDocInfo(data) {
    return this.http.post(
      `/api/internals3decisiondoc/storeDecisionDocInfo`,
      data,
      { observe: "response" }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/consultant-decision.service.ts